export default "__VITE_PUBLIC_ASSET__ce1a72a3__"